<template>
  <div class="mx-4">
    <h1 class="text-white text-center text-lg font-bold p-4">ثبت بازدید</h1>

    <div class="rounded-xl p-4 bg-gray-900">
      <form action="" @submit.prevent="submit()">
        <Input type="text" placeholder="نام و نام خانوادگی" v-model="note.Referred" required/>

        <Input type="tel" class="mt-4" placeholder="شماره همراه" v-model="note.Mobile" required/>

        <Input type="number" class="mt-4" placeholder="تعداد مهمان" v-model="note.GuestCount" required/>

        <select class="mt-4 w-full rounded-xl p-2 bg-white text-black" v-model="note.CeremonyType" required>
          <option value="" selected disabled>نوع مراسم</option>
          <option
              v-for="type in ceremonyTypes"
              :key="type"
              :value="type.Code">
            {{ type.Title }}
          </option>
        </select>

         <select class="mt-4 w-full rounded-xl p-2 bg-white text-black" v-model="note.Code" required>
          <option value="" selected disabled>نحوه آشنایی بامجموعه</option>
          <option
              v-for="type2 in Code"
              :key="type2"
              :value="type2.Code">
            {{ type2.Title }}
          </option>
        </select>

        <div class="flex items-center mt-4">
          <div class="rounded-xl bg-yellow-500 p-2">
            <CalendarIcon class="w-5 h-5"/>
          </div>
          <Input id="datetimepicker" class="mr-2" placeholder="تاریخ مراسم" v-model="note.CeremonyDate" required/>
        </div>

        <date-picker class="mt-4" color="#f59e0b" v-model="note.CeremonyDate" custom-input="#datetimepicker"/>

        <Button class="mt-4" type="submit">ثبت</Button>

      </form>
    </div>

    <div v-if="mode === 'edit'">
      <h1 class="text-white text-center text-lg font-bold p-4">پیگیری ها</h1>
      <Button class="mb-4" @click="modal = true; this.description = ''">ثبت پیگیری</Button>

      <div class="mb-4" v-if="note.details.length > 0">
        <div class="rounded-xl p-4 bg-gray-900 my-4"
             v-for="detail in note.details"
             :key="detail.Id">
          <div class="flex justify-between items-center">
            <div class="flex text-sm">
              <ClockIcon class="h-5 w-5 text-yellow-300"/>
              <span class="mr-1 text-white">{{ detail.FollowDate }}</span>
            </div>
            <Button class="w-auto py-1 px-2 text-xs" @click="editFollowUp(detail)">ویرایش</Button>
          </div>
          <span class="mr-1 text-white text-xs">{{ detail.FollowDescription }}</span>
        </div>
      </div>

      <div class="border border-gray-400 rounded-lg py-4" v-else>
        <h1 class="text-gray-400 text-center">هنوز پیگیری ثبت نشده است.</h1>
      </div>

    </div>

  </div>


  <!--  Modal -->
  <transition name="fade">
    <div class="flex justify-center items-center fixed top-0 bg-gray-500/60 h-full w-full"
         v-if="modal" @click="modal = !modal">
      <div class="bg-gray-800 rounded-lg w-3/4 p-4" @click.stop>
        <h1 class="text-center text-white">ثبت پیگیری</h1>
        <form action="" class="mt-2">
          <textarea class="p-2 w-full rounded-lg" placeholder="توضیحات..." v-model="this.followUp.description"></textarea>
          <Button class="mt-2" @click="submitFollowUp()">ثبت</Button>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
import Input from "@/components/Input";
import Button from "@/components/General/Button";
import {CalendarIcon, ClockIcon} from "@heroicons/vue/outline";
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'
import {
  getCeremony,
  getCeremonyType,
  getCeremonyFamiliarity,
  postCeremony,
  postCeremonyFollowUp,
  updateCeremony,
  updateCeremonyFollowUp
} from "../API/API";

export default {
  name: "Reserve",
  components: {Input, Button, ClockIcon, datePicker: Vue3PersianDatetimePicker, CalendarIcon},
  data() {
    return {
      mode: "create",
      ceremonyTypes: [],
      Code:[],
      note: {
        Referred: '',
        Mobile: '',
        GuestCount: '',
        CeremonyDate: '',
        CeremonyType: '',
        Code:'',
        details: []
      },
      followUp: {
        id: '',
        description: '',
      },
      modal: false,
      modalMode: 'create'
    }
  },
  async created() {
    if (this.$route.params.id !== 'create') {
      this.mode = 'edit';
      this.note = (await getCeremony(this.$route.params.id)).data.result
    }
    this.ceremonyTypes = (await getCeremonyType()).data.result
    this.Code = (await getCeremonyFamiliarity()).data.result
  },
  methods: {
    submit() {
      if (this.mode === 'edit') {
        this.updateCeremony()
      } else {
        this.createCeremony()
      }

    },
    createCeremony() {
    console.log(this.note)
      postCeremony(this.note)
          .then(resp => {
            this.$swal({
              icon: 'success',
              title: 'موفق',
              text: resp.data.message,
              confirmButtonColor: '#fcd34d',
              confirmButtonText: 'باشه'
            }).then(() => {
              this.$router.replace('/note-list')
            })
          })
          .catch(err => {
            this.$swal({
              icon: 'error',
              title: 'خطا',
              text: err.response.data.message,
              confirmButtonColor: '#fcd34d',
              confirmButtonText: 'باشه'
            })
          })
    },
    updateCeremony() {
     updateCeremony(this.note.Id, this.note)
          .then(resp => {
            this.$swal({
              icon: 'success',
              title: 'موفق',
              text: resp.data.message,
              confirmButtonColor: '#fcd34d',
              confirmButtonText: 'باشه'
            }).then(() => {
              this.$router.replace('/note-list')
            })
          })
          .catch(err => {
            this.$swal({
              icon: 'error',
              title: 'خطا',
              text: err.response.data.message,
              confirmButtonColor: '#fcd34d',
              confirmButtonText: 'باشه'
            })
          })
    },
    submitFollowUp() {
      let followUp = {
        FollowDescription: this.followUp.description,
        Id: this.followUp.Id,
        HId: this.note.Id,
      }
      if (this.modalMode === 'edit') {
        this.updateFollowUp(followUp)
      } else {
        this.createFollowUp(followUp)
      }
    },
    editFollowUp(detail) {
      this.modal = true
      this.modalMode = 'edit'
      this.followUp.description = detail.FollowDescription
      this.followUp.Id = detail.Id
    },
    createFollowUp(followUp) {
      postCeremonyFollowUp(followUp)
          .then(async resp => {
            this.$swal({
              icon: 'success',
              title: 'موفق',
              text: resp.data.message,
              confirmButtonColor: '#fcd34d',
              confirmButtonText: 'باشه'
            })
            this.note = (await getCeremony(this.$route.params.id)).data.result
          })
          .finally(() => {
            this.modal = false
          })
    },
    updateFollowUp(followUp) {
      followUp.Id =
      updateCeremonyFollowUp(followUp)
          .then(async resp => {
            this.$swal({
              icon: 'success',
              title: 'موفق',
              text: resp.data.message,
              confirmButtonColor: '#fcd34d',
              confirmButtonText: 'باشه'
            })
            this.note = (await getCeremony(this.$route.params.id)).data.result
          })
          .catch(err => {
            this.$swal({
              icon: 'error',
              title: 'خطا',
              text: err.response.data.result,
              confirmButtonColor: '#fcd34d',
              confirmButtonText: 'باشه'
            })
          })
          .finally(() => {
            this.modal = false
            this.modalMode = 'create'
            this.description = ''
          })
    }
  }
}
</script>

<style scoped>

</style>